document.addEventListener('DOMContentLoaded', function () {
  const pickers = document.querySelectorAll('.jt-fulfillment');

  // =========================
  // DATE HELPERS
  // =========================

  function parseLocalDate(value) {
    if (!value) return null;

    const parts = value.split('-');
    if (parts.length !== 3) return null;

    return new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );
  }

  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  function formatDisplayDate(date) {
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + Number(days || 0));
    return result;
  }

  // Business days = Monday–Friday
  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;

    while (added < Number(days || 0)) {
      result.setDate(result.getDate() + 1);

      const day = result.getDay();

      if (day >= 1 && day <= 5) {
        added++;
      }
    }

    return result;
  }

  function isSunday(date) {
    return date.getDay() === 0;
  }

  function sameDate(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  // =========================
  // U.S. FEDERAL HOLIDAYS
  // =========================

  function nthWeekdayOfMonth(year, month, weekday, nth) {
    const date = new Date(year, month, 1);

    while (date.getDay() !== weekday) {
      date.setDate(date.getDate() + 1);
    }

    date.setDate(date.getDate() + (nth - 1) * 7);

    return date;
  }

  function lastWeekdayOfMonth(year, month, weekday) {
    const date = new Date(year, month + 1, 0);

    while (date.getDay() !== weekday) {
      date.setDate(date.getDate() - 1);
    }

    return date;
  }

  function observedFixedHoliday(year, month, day) {
    const actual = new Date(year, month, day);
    const observed = new Date(actual);

    if (actual.getDay() === 6) {
      observed.setDate(observed.getDate() - 1);
    } else if (actual.getDay() === 0) {
      observed.setDate(observed.getDate() + 1);
    }

    return observed;
  }

  function getFederalHolidayDates(year) {
    const holidays = [];

    function add(date) {
      holidays.push(formatDate(date));
    }

    function addFixed(month, day) {
      const actual = new Date(year, month, day);
      const observed = observedFixedHoliday(year, month, day);

      add(actual);
      add(observed);
    }

    // New Year's Day
    addFixed(0, 1);

    // Martin Luther King Jr. Day
    add(nthWeekdayOfMonth(year, 0, 1, 3));

    // Washington's Birthday / Presidents Day
    add(nthWeekdayOfMonth(year, 1, 1, 3));

    // Memorial Day
    add(lastWeekdayOfMonth(year, 4, 1));

    // Juneteenth
    addFixed(5, 19);

    // Independence Day
    addFixed(6, 4);

    // Labor Day
    add(nthWeekdayOfMonth(year, 8, 1, 1));

    // Columbus Day
    add(nthWeekdayOfMonth(year, 9, 1, 2));

    // Veterans Day
    addFixed(10, 11);

    // Thanksgiving
    add(nthWeekdayOfMonth(year, 10, 4, 4));

    // Christmas
    addFixed(11, 25);

    return [...new Set(holidays)];
  }

  function isFederalHoliday(date) {
    if (!date) return false;

    return getFederalHolidayDates(
      date.getFullYear()
    ).includes(formatDate(date));
  }

  function isClosedDate(date) {
    return (
      isSunday(date) ||
      isFederalHoliday(date)
    );
  }

  function nextOpenDate(date) {
    const result = new Date(date);

    while (isClosedDate(result)) {
      result.setDate(result.getDate() + 1);
    }

    return result;
  }

  function getPreorderMinimumDate(today, leadTime, leadTimeType) {
    let minimumDate;

    if (leadTimeType === 'Business Days') {
      minimumDate = addBusinessDays(today, leadTime);
    } else {
      minimumDate = addDays(today, leadTime);
    }

    return nextOpenDate(minimumDate);
  }

  // =========================
  // TIME HELPERS
  // =========================

  function formatHour(hour) {
    const hour12 = hour % 12 || 12;
    const suffix = hour < 12 ? 'AM' : 'PM';

    return `${hour12} ${suffix}`;
  }

  function addTimeOption(select, startHour, endHour) {
    const option = document.createElement('option');

    const label =
      `${formatHour(startHour)}–${formatHour(endHour)}`;

    option.value = label;
    option.textContent = label;

    select.appendChild(option);
  }

  function buildTimes(select, date, rule) {
    select.innerHTML = '';

    if (!date || isClosedDate(date)) {
      const option = document.createElement('option');

      option.value = '';
      option.textContent = 'Please select a date first';
      option.selected = true;

      select.appendChild(option);
      select.disabled = true;

      return;
    }

    select.disabled = false;

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Select a time';
    placeholder.selected = true;

    select.appendChild(placeholder);

    const currentTime = new Date();

    const currentDate = new Date(
      currentTime.getFullYear(),
      currentTime.getMonth(),
      currentTime.getDate()
    );

    const isSameDayOrder =
      rule === 'Same-Day & Next-Day' &&
      sameDate(date, currentDate);

      const isPreservedFlower =
        select.closest('.jt-fulfillment')?.dataset.preservedFlower === 'true';

      const isPreservedFlowerToday =
        isPreservedFlower &&
        sameDate(date, currentDate);

    let optionsAdded = 0;

    for (let hour = 12; hour <= 17; hour++) {

      if (isSameDayOrder) {
        const slotStart = new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          hour,
          0,
          0
        );

        const minimumReadyTime =
          new Date(currentTime.getTime() + 2 * 60 * 60 * 1000);

        if (slotStart < minimumReadyTime) {
          continue;
        }
      }

      /*
        Preserved Flowers:
        When ordering for today, remove the current
        time slot and all earlier slots.

        Example:
        12:10 PM -> earliest option is 1 PM–2 PM.
      */
      if (isPreservedFlowerToday) {
        if (hour <= currentTime.getHours()) {
          continue;
        }
      }

      addTimeOption(
        select,
        hour,
        hour + 1
      );

      optionsAdded++;
    }

    if (optionsAdded === 0) {
      select.innerHTML = '';

      const option =
        document.createElement('option');

      option.value = '';
      option.textContent =
        'No same-day time slots available';

      option.selected = true;

      select.appendChild(option);
      select.disabled = true;
    }
  }

  // =========================
  // INITIALIZE
  // =========================

  pickers.forEach(function (picker) {
    const dateInput =
      picker.querySelector('.jt-requested-date');

    const timeSelect =
      picker.querySelector('.jt-requested-time');

    const trigger =
      picker.querySelector('.jt-date-trigger');

    const triggerText =
      picker.querySelector('.jt-date-trigger__text');

    const calendar =
      picker.querySelector('.jt-calendar');

    const monthLabel =
      picker.querySelector('.jt-calendar__month');

    const daysContainer =
      picker.querySelector('.jt-calendar__days');

    const prevButton =
      picker.querySelector('.jt-calendar__prev');

    const nextButton =
      picker.querySelector('.jt-calendar__next');

    if (
      !dateInput ||
      !timeSelect ||
      !trigger ||
      !calendar ||
      !monthLabel ||
      !daysContainer ||
      !prevButton ||
      !nextButton
    ) {
      return;
    }

    const rule =
      (picker.dataset.rule || '').trim();

    // Only these two product pages use
    // the recurring subscription 7-day rule.
    const isSubscriptionProduct =
      window.location.pathname.includes(
        '/products/signature-mixed-bouquet'
      ) ||
      window.location.pathname.includes(
        '/products/mystery-bloom-box'
      );

    const earliest =
      parseLocalDate(picker.dataset.earliest);

    const latest =
      parseLocalDate(picker.dataset.latest);

    const leadTime =
      Number(picker.dataset.leadTime || 0);

    const leadTimeType =
      (picker.dataset.leadTimeType || '').trim();

    const now = new Date();

    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const afterSameDayCutoff =
      now.getHours() >= 15;

    // =========================
    // CALCULATE ALLOWED RANGE
    // =========================

    let minimumDate = new Date(today);
    let maximumDate =
      latest ? new Date(latest) : null;

    // Normal product rules remain unchanged.

    if (rule === 'Fixed Date') {
      const fixedDate =
        earliest || latest;

      if (fixedDate) {
        minimumDate =
          new Date(fixedDate);

        maximumDate =
          new Date(fixedDate);
      }
    }

    else if (rule === 'Date Range') {
      if (
        earliest &&
        earliest > minimumDate
      ) {
        minimumDate =
          new Date(earliest);
      }
    }

    else if (rule === 'Preorder') {
      minimumDate =
        getPreorderMinimumDate(
          today,
          leadTime,
          leadTimeType
        );

      if (
        earliest &&
        earliest > minimumDate
      ) {
        minimumDate =
          new Date(earliest);
      }
    }

    else if (rule === 'Same-Day & Next-Day') {
      if (afterSameDayCutoff) {
        minimumDate =
          nextOpenDate(
            addDays(today, 1)
          );
      } else {
        minimumDate =
          nextOpenDate(today);
      }

      maximumDate = null;
    }

    else {
      if (
        earliest &&
        earliest > minimumDate
      ) {
        minimumDate =
          new Date(earliest);
      }

      minimumDate =
        nextOpenDate(minimumDate);
    }

    // =========================
    // SUBSCRIPTION OVERRIDE
    // =========================
    //
    // Signature Mixed Bouquet
    // Mystery Bloom Box
    //
    // Require at least 7 calendar days
    // advance notice.
    //
    // Example:
    // Sep 23 -> Sep 30
    //
    // If the 7th day is Monday or a
    // U.S. federal holiday, move forward
    // to the next open date.
    // =========================

    if (isSubscriptionProduct) {
      minimumDate =
        nextOpenDate(
          addDays(today, 7)
        );

      maximumDate = null;
    }

    // =========================
    // DATE VALIDATION
    // =========================

    function isDateAvailable(date) {
      if (!date) return false;

      if (isClosedDate(date)) {
        return false;
      }

      if (
        minimumDate &&
        date < minimumDate
      ) {
        return false;
      }

      if (
        maximumDate &&
        date > maximumDate
      ) {
        return false;
      }

      /*
        For normal products, preserve
        metafield earliest/latest limits.

        Subscription products use the
        dedicated 7-day rule above instead.
      */

      if (
        !isSubscriptionProduct &&
        earliest &&
        date < earliest
      ) {
        return false;
      }

      if (
        !isSubscriptionProduct &&
        latest &&
        date > latest
      ) {
        return false;
      }

      return true;
    }

    // =========================
    // CALENDAR
    // =========================

    let selectedDate =
      parseLocalDate(dateInput.value);

    let viewDate =
      selectedDate
        ? new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            1
          )
        : new Date(
            minimumDate.getFullYear(),
            minimumDate.getMonth(),
            1
          );

    function renderCalendar() {
      daysContainer.innerHTML = '';

      monthLabel.textContent =
        viewDate.toLocaleDateString(
          'en-US',
          {
            month: 'long',
            year: 'numeric'
          }
        );

      const year =
        viewDate.getFullYear();

      const month =
        viewDate.getMonth();

      const firstDay =
        new Date(
          year,
          month,
          1
        ).getDay();

      const daysInMonth =
        new Date(
          year,
          month + 1,
          0
        ).getDate();

      for (
        let i = 0;
        i < firstDay;
        i++
      ) {
        const blank =
          document.createElement('span');

        blank.className =
          'jt-calendar__blank';

        daysContainer.appendChild(
          blank
        );
      }

      for (
        let day = 1;
        day <= daysInMonth;
        day++
      ) {
        const date =
          new Date(
            year,
            month,
            day
          );

        const button =
          document.createElement(
            'button'
          );

        button.type = 'button';
        button.textContent = day;
        button.className =
          'jt-calendar__day';

        if (
          sameDate(
            date,
            today
          )
        ) {
          button.classList.add(
            'jt-calendar__day--today'
          );
        }

        if (
          selectedDate &&
          sameDate(
            date,
            selectedDate
          )
        ) {
          button.classList.add(
            'jt-calendar__day--selected'
          );
        }

        if (
          !isDateAvailable(date)
        ) {
          button.disabled = true;

          button.classList.add(
            'jt-calendar__day--disabled'
          );
        } else {
          button.addEventListener(
            'click',
            function () {
              selectedDate =
                new Date(date);

              dateInput.value =
                formatDate(
                  selectedDate
                );

              triggerText.textContent =
                formatDisplayDate(
                  selectedDate
                );

              buildTimes(
                timeSelect,
                selectedDate,
                rule
              );

              calendar.hidden =
                true;

              trigger.setAttribute(
                'aria-expanded',
                'false'
              );

              renderCalendar();
            }
          );
        }

        daysContainer.appendChild(
          button
        );
      }

      const previousMonth =
        new Date(
          year,
          month - 1,
          1
        );

      const minimumMonth =
        new Date(
          minimumDate.getFullYear(),
          minimumDate.getMonth(),
          1
        );

      prevButton.disabled =
        previousMonth < minimumMonth;

      if (maximumDate) {
        const nextMonth =
          new Date(
            year,
            month + 1,
            1
          );

        const maximumMonth =
          new Date(
            maximumDate.getFullYear(),
            maximumDate.getMonth(),
            1
          );

        nextButton.disabled =
          nextMonth > maximumMonth;
      } else {
        nextButton.disabled =
          false;
      }
    }

    // =========================
    // OPEN / CLOSE CALENDAR
    // =========================

    trigger.addEventListener(
      'click',
      function () {
        calendar.hidden =
          !calendar.hidden;

        trigger.setAttribute(
          'aria-expanded',
          String(!calendar.hidden)
        );

        if (!calendar.hidden) {
          renderCalendar();
        }
      }
    );

    prevButton.addEventListener(
      'click',
      function () {
        viewDate =
          new Date(
            viewDate.getFullYear(),
            viewDate.getMonth() - 1,
            1
          );

        renderCalendar();
      }
    );

    nextButton.addEventListener(
      'click',
      function () {
        viewDate =
          new Date(
            viewDate.getFullYear(),
            viewDate.getMonth() + 1,
            1
          );

        renderCalendar();
      }
    );

    document.addEventListener(
      'click',
      function (event) {
        if (
          !picker.contains(
            event.target
          )
        ) {
          calendar.hidden =
            true;

          trigger.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      }
    );

    // =========================
    // RESTORED DATE
    // =========================

    if (
      selectedDate &&
      isDateAvailable(
        selectedDate
      )
    ) {
      triggerText.textContent =
        formatDisplayDate(
          selectedDate
        );

      buildTimes(
        timeSelect,
        selectedDate,
        rule
      );
    } else {
      dateInput.value = '';
      selectedDate = null;

      buildTimes(
        timeSelect,
        null,
        rule
      );
    }

    renderCalendar();
  });
});